import React from 'react';
import { useStudioTypeSize } from '../../StudioTypeScale';
import { studioCopy } from '../../../../utils/contentCopy';
import SpotlightFrame, { type SpotlightInjectedProps, type SpotlightLayoutProps } from './SpotlightFrame';

const SpotlightStatHighlightContent: React.FC<SpotlightInjectedProps & { content: any }> = ({
  content,
  tokens,
  isStory,
  locale
}) => {
  const t = tokens!;
  const typeSize = useStudioTypeSize();
  const chipLabel = studioCopy.statChip(content, locale);

  return (
    <div>
      <div
        style={{
          display: 'inline-block',
          padding: isStory ? '6px 10px' : '5px 8px',
          border: `1px solid ${t.accent}`,
          color: t.accent,
          fontSize: typeSize(isStory ? 9.5 : 8),
          fontWeight: 900,
          letterSpacing: 1.8,
          textTransform: 'uppercase'
        }}
      >
        {chipLabel}
      </div>
      <div
        style={{
          margin: isStory ? '20px 0 0' : '15px 0 0',
          color: t.accent,
          fontSize: typeSize(isStory ? 92 : 73),
          fontWeight: 950,
          letterSpacing: '-5px',
          lineHeight: 0.9,
          textShadow: `7px 7px 0 rgba(255,255,255,0.08)`
        }}
      >
        {content.stat}
      </div>
      <div
        style={{
          maxWidth: 300,
          marginTop: isStory ? 16 : 12,
          color: t.ink,
          fontSize: typeSize(isStory ? 21 : 17),
          fontWeight: 900,
          letterSpacing: '-0.4px',
          lineHeight: 1.25
        }}
      >
        {content.label}
      </div>
      {content.description ? (
        <div
          style={{
            position: 'relative',
            maxWidth: 290,
            marginTop: isStory ? 28 : 20,
            padding: isStory ? '17px 17px 17px 20px' : '13px 14px 13px 17px',
            border: `1px solid ${t.line}`,
            background: t.panel,
            color: t.muted,
            fontSize: typeSize(isStory ? 13 : 11),
            fontWeight: 600,
            lineHeight: 1.58
          }}
        >
          <span
            style={{
              position: 'absolute',
              top: -1,
              right: -1,
              width: isStory ? 30 : 24,
              height: isStory ? 30 : 24,
              borderTop: `4px solid ${t.accent}`,
              borderRight: `4px solid ${t.accent}`
            }}
          />
          {content.description}
        </div>
      ) : null}
    </div>
  );
};

const SpotlightStatHighlightLayout: React.FC<SpotlightLayoutProps> = props => (
  <SpotlightFrame {...props}>
    <SpotlightStatHighlightContent content={props.content || {}} />
  </SpotlightFrame>
);

export default SpotlightStatHighlightLayout;
